export const state = {
  routes: [],
  dynamicRoutes: [],
  routesLoaded: false
}
